(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-automation-conf', {
            parent: 'entity',
            url: '/communication-automation-conf?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT','ROLE_AREA_CONFIGURATION'],
                pageTitle: 'wamasysApp.communicationAutomationConf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-confs.html',
                    controller: 'CommunicationAutomationConfController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-automation-conf-detail', {
            parent: 'entity',
            url: '/communication-automation-conf/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT','ROLE_AREA_CONFIGURATION'],
                pageTitle: 'wamasysApp.communicationAutomationConf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-detail.html',
                    controller: 'CommunicationAutomationConfDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationAutomationConf', function($stateParams, CommunicationAutomationConf) {
                    return CommunicationAutomationConf.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-automation-conf.new', {
            parent: 'communication-automation-conf',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-form.html',
                    controller: 'CommunicationAutomationConfFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        delayHour: 1,
                        id: null,
                        type: 'BILLING_NOTICE'
                    };
                }
            }
        })
        .state('communication-automation-conf.edit', {
            parent: 'communication-automation-conf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-form.html',
                    controller: 'CommunicationAutomationConfFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationAutomationConf', function($stateParams, CommunicationAutomationConf) {
                    return CommunicationAutomationConf.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-automation-conf.delete', {
            parent: 'communication-automation-conf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-delete-dialog.html',
                    controller: 'CommunicationAutomationConfDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationAutomationConf', function(CommunicationAutomationConf) {
                            return CommunicationAutomationConf.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-automation-conf', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
